// extracted by mini-css-extract-plugin
module.exports = {"jobCardDE-body":"jobCardDE-body","jobCardDE-body__right":"jobCardDE-body__right","jobCardDE-body__appeal":"jobCardDE-body__appeal"};